<template>
  <div class="landing" fluid fill-height>
    <v-progress-linear indeterminate color="primary" height="20"></v-progress-linear>
    <v-card-text class="text-caption text-center">
      {{ $t('message.loading_jiu_jitsu') }}
    </v-card-text>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  created() {
    this.setLang();
    this.isAppDisplay();
  },
}
</script>

<style scoped></style>